import { PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD } from "../PasswordTextField";

export default function isEnoughPasswordProgress(progress: number) {
    return progress > PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD;
}
